import SearchableSelect from "../../../../components/SearchableSelect";

export default function PlatformExperience() {
  return (<>
      <section className="section-space whatsapp-section" id="experience">
        <div className="container whatsapp-grid">
          <div className="phone-wrap reveal">
            <div className="phone">
              <div className="phone-notch"></div>
              <div className="wa-header">
                <div className="wa-avatar">{"AI"}</div>
                <div><strong>{"Business Assistant"}</strong><small>{"Online"}</small></div>
              </div>
              <div className="wa-chat" id="waChat">
                <div className="bubble incoming">{"Hi 👋 How can I help you today?"}</div>
                <div className="bubble outgoing">{"I want to book apartment A-1204."}</div>
                <div className="bubble incoming">{"Certainly. I found the unit. Would you like me to check availability, payment plan or booking amount?"}</div>
              </div>
              <div className="wa-action-row">
                <button data-reply="availability">{"Check availability"}</button>
                <button data-reply="payment">{"Payment plan"}</button>
              </div>
            </div>
          </div>

          <div className="whatsapp-copy reveal delay-1">
            <div className="eyebrow">{"WHATSAPP AI"}</div>
            <h2>{"Turn WhatsApp into a business channel."}</h2>
            <p>{"Give your AI agent your business knowledge, connect it with your systems, and let it answer questions, create bookings, check orders, collect information or hand conversations to your team."}</p>
            <div className="mini-flow">
              <span>{"Customer"}</span><i>{"→"}</i><span>{"WhatsApp"}</span><i>{"→"}</i><span>{"AI Agent"}</span><i>{"→"}</i><span>{"CRM / Booking / Orders"}</span><i>{"→"}</i><span>{"Human Agent"}</span>
            </div>
            <a href="#contact" className="btn btn-primary">{"Explore WhatsApp AI"}</a>
          </div>
        </div>
      </section>

      <section className="section-space" id="managed">
        <div className="container">
          <div className="section-heading centered reveal">
            <div className="eyebrow">{"MANAGED SERVICES"}</div>
            <h2>{"Technology should run. Not become another job."}</h2>
            <p>{"Access engineering, operations, QA, security and support capabilities without building every function internally."}</p>
          </div>
          <div className="managed-grid">
            <article className="managed-card reveal"><span>{"DEVOPS"}</span><h3>{"Managed DevOps"}</h3><p>{"Infrastructure monitoring, deployments, CI/CD, backups, incident response and optimization."}</p><a href="#contact">{"From $99/mo →"}</a></article>
            <article className="managed-card reveal delay-1"><span>{"ENGINEERING"}</span><h3>{"Managed Development"}</h3><p>{"Flexible engineering capacity for development, integrations, bug fixing and enhancement."}</p><a href="#contact">{"From $199/mo →"}</a></article>
            <article className="managed-card reveal delay-2"><span>{"QUALITY"}</span><h3>{"Managed QA"}</h3><p>{"Continuous manual and automated testing across releases, browsers and APIs."}</p><a href="#contact">{"From $99/mo →"}</a></article>
            <article className="managed-card reveal"><span>{"SECURITY"}</span><h3>{"Managed Security"}</h3><p>{"Security reviews, vulnerability management and remediation assistance."}</p><a href="#contact">{"From $149/mo →"}</a></article>
            <article className="managed-card reveal delay-1"><span>{"SUPPORT"}</span><h3>{"Managed Customer Support"}</h3><p>{"Customer service operations using your workflows, knowledge base and escalation rules."}</p><a href="#contact">{"From $99/mo →"}</a></article>
          </div>
        </div>
      </section>

      <section className="section-space globe-section">
        <div className="container globe-grid">
          <div className="globe-copy reveal">
            <div className="eyebrow light">{"GLOBAL PLATFORM"}</div>
            <h2>{"Built for businesses everywhere."}</h2>
            <p>{"One platform. Local configuration. Global delivery."}</p>
            <label htmlFor="countrySelect">{"Select market"}</label>
            <SearchableSelect id="countrySelect" defaultValue="Pakistan">
              <option value="UAE">{"United Arab Emirates"}</option>
              <option value="Saudi Arabia">{"Saudi Arabia"}</option>
              <option value="Pakistan">{"Pakistan"}</option>
              <option value="United Kingdom">{"United Kingdom"}</option>
              <option value="United States">{"United States"}</option>
              <option value="Singapore">{"Singapore"}</option>
              <option value="Malaysia">{"Malaysia"}</option>
            </SearchableSelect>
            <div className="country-info" id="countryInfo">
              <div><small>{"Currency"}</small><strong>{"PKR"}</strong></div>
              <div><small>{"Service availability"}</small><strong>{"Configured locally"}</strong></div>
              <div><small>{"Payments"}</small><strong>{"Partner dependent"}</strong></div>
            </div>
          </div>

          <div className="globe-visual reveal delay-1">
            <div className="orb">
              <div className="orbit orbit-a"></div>
              <div className="orbit orbit-b"></div>
              <div className="dot dot-a"></div>
              <div className="dot dot-b"></div>
              <div className="dot dot-c"></div>
              <div className="orb-label">{"GLOBAL"}<br />{"DELIVERY"}</div>
            </div>
          </div>
        </div>
      </section>

  </>);
}
